import React from 'react';
import './game-logo.scss';

function GameLogo({ gameName }) {
  return (
    <div className='cpt-game-logo-container'>
      <div className={`cpt-game-name-logo ${gameName}`} />
    </div>
  );
}
export default GameLogo;
